import { Outlet, useParams } from 'react-router-dom'
import DocsHeader from './DocsHeader'
import DocsSidebar from './DocsSidebar'
import DocsTableOfContents from './DocsTableOfContents'
import Footer from '../Footer'
import './DocsLayout.css'

function DocsLayout() {
  const { version = 'latest', lang = 'en' } = useParams()

  return (
    <div className='docs-layout'>
      <DocsHeader version={version} lang={lang} />

      <div className='docs-container'>
        <DocsSidebar version={version} lang={lang} />

        <main className='docs-content'>
          <article className='docs-article'>
            <Outlet />
          </article>
        </main>

        <aside className='docs-toc'>
          <DocsTableOfContents />
        </aside>
      </div>

      <Footer />
    </div>
  )
}

export default DocsLayout
